import { BaseService } from "mrb/core";
import { CertifierDashboardApiRouteService } from "common/services";

class CertifierDashboardService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new CertifierDashboardApiRouteService());
    }

    findCertifierModes(filter, abortSignal = null) {
        const url = this.routeService.findCertifierModes(filter);
        return this.apiClient.get(url, null, abortSignal);
    }

    getSummary(modeId, abortSignal = null) {
        const url = this.routeService.getSummary(modeId);
        return this.apiClient.get(url, null, abortSignal);
    }

    findContent(modeId, filter, abortSignal = null) {
        const url = this.routeService.findContent(modeId, filter);
        return this.apiClient.get(url, null, abortSignal);
    }

    updateContentStatus(modeId, contentId, isApproved, contentType, abortSignal = null) {
        const url = this.routeService.updateContentStatus(modeId, contentId);
        return this.apiClient.put(url, { isApproved, contentType }, null, abortSignal);
    }

    bulkUpdateContentStatus(modeId, payload, abortSignal = null) {
        const url = this.routeService.bulkUpdateContentStatus(modeId);
        return this.apiClient.put(url, payload, null, abortSignal);
    }
}

export default CertifierDashboardService;
